import React, { memo } from "react";
import ClockIcon from "assets/images/images_new/sidebar-icons/clock.png";

const PracticeClockMain = memo(function PracticeClockMain({
   hours, minutes, seconds
//   time
   }) {
  return (
    <div className="time-spent" style={{cursor: 'default'}}>
      <img src={ClockIcon} alt="Badge" />
      <span>Time Spent:</span> {hours}h : {minutes}m : {seconds}s
    </div>
  );
});

export default PracticeClockMain;
